/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l = (r, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(r, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function f(r, t) {
  return (e, n, a) => {
    const u = (c) => {
      var o;
      return ((o = c.renderRoot) == null ? void 0 : o.querySelector(r)) ?? null;
    };
    return l(e, n, { get() {
      return u(this);
    } });
  };
}
export {
  l as a,
  f as e
};
